import { getResourceTypeName, type ResourceType } from "@/modules/api/resourceTypes.tsx";
import { registerErrorField } from "@/modules/error/errorFields.ts";
import { SimpleLocalizedError, type LocalizedError, type Translatable } from "@/modules/l10n/getTransText.ts";
import { Trans } from "@lingui/react/macro";
import { take } from "@warrenio/utils/collections/take";
import { isArray } from "remeda";

export class ResourceNotFoundError extends SimpleLocalizedError implements LocalizedError {
    name = "ResourceNotFoundError";

    public resourceTypeName: Translatable;

    constructor(
        public readonly type: ResourceType,
        public readonly id: string | number,
        /** For debugging */
        public readonly availableIds: unknown[] = [],
    ) {
        const resourceTypeName = getResourceTypeName(type);
        super(
            <Trans comment="{resourceTypeName} is eg. 'virtual machine' or 'billing account'">
                {resourceTypeName} with ID {id} not found
            </Trans>,
        );
        this.resourceTypeName = resourceTypeName;
    }
}

registerErrorField("availableIds", isArray);

// XXX: Not suppressed since there seem to be some bugs still which cause this to be thrown
// suppressErrorClass(ResourceNotFoundError);

export function getResourceById<T, TId extends string | number>(
    resources: Map<TId, T>,
    id: TId,
    type: ResourceType,
): T {
    const resource = resources.get(id);
    if (!resource) {
        throw new ResourceNotFoundError(type, id, take(resources.keys(), 30));
    }
    return resource;
}
